import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  async connect () {
    const { default: Alert } = await import('bootstrap/js/dist/alert')
    this.alertInstance = Alert.getOrCreateInstance(this.element)
  }
}
